import { useEffect, useState } from 'react'
import {
  Badge,
  Box,
  Button,
  Center,
  Flex,
  Image,
  Input,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Tr,
  useToast
} from '@chakra-ui/react'

import Modal from '../../modal'
import { useRanContext } from '../../ran-state-provider'

import {
  getUserAccountInfo,
  convertReferralPointsToEPoints
} from '../../../lib/api-helper'

import {
  getClassImage,
  getSchoolSmallLogo
} from '../../../lib/ran-helper'

const View = ({ onClose }) => {
  const toast = useToast()
  const { setUserBasicInfo, setAuthentication } = useRanContext()

  const [isLoading, setLoading] = useState(true)
  const [data, setData] = useState({})

  const [openPinModal, setOpenPinModal] = useState(false)
  const [pinCode, setPinCode] = useState('')

  useEffect(() => {
    fetchInitialData()
  }, [])

  const fetchInitialData = async () => {
    setLoading(true)

    const result = await getUserAccountInfo(setAuthentication)

    if (result?.status === 200) {
      const normalized = {
        ...result.data,
        referralPoints:
          result.data.referralPoints ??
          result.data.ReferralPoints
      }

      setUserBasicInfo(normalized)
      setData(normalized)
    }

    setLoading(false)
  }

  const handleConvert = async () => {
    const result = await convertReferralPointsToEPoints(
      pinCode,
      setAuthentication
    )

    if (!result) return

   if (result.success) {
  toast({
    title: 'Conversion Successful',
    description: `Converted ${data.referralPoints} Referral Points to E-Points.`,
    status: 'success',
    duration: 3000
  })

  // Immediate UI update
  setData(prev => ({ ...prev, referralPoints: 0 }))

  setOpenPinModal(false)
  setPinCode('')
} else {
 

  toast({
    title: 'Conversion Failed',
    description: result.errors[0],
    status: 'error',
    duration: 3000
  })
}
  }

  return (
    <>
      <Modal header="ACCOUNT INFO" isOpen onClose={onClose} fitContent>
        {isLoading ? (
          <Center>
            <Spinner />
          </Center>
        ) : (
          <>
            <TableContainer>
              <Table size="sm">
              <Tbody>
                <Tr>
                  <Td>Username</Td>
                  <Td>
                    <b>{data.username}</b>
                  </Td>
                </Tr>
                <Tr>
                  <Td>Email address</Td>
                  <Td>
                    <b>{data.email}</b>
                  </Td>
                </Tr>
                <Tr>
                  <Td>Status</Td>
                  <Td>
                    <b>{data.status}</b>
                  </Td>
                </Tr>
                <Tr>
                  <Td>Last Login Date</Td>
                  <Td>
                    <b>{data.lastLoginDate}</b>
                  </Td>
                </Tr>
                <Tr>
                  <Td>Last Used IP Address</Td>
                  <Td>
                    <b>{data.lastUsedIPAddress}</b>
                  </Td>
                </Tr>
                <Tr>
                    <Td>Referral Points</Td>
                    <Td>
                      <Flex align="center" gap={2}>
                        <b>{data.referralPoints || 0}</b>

                        <Button
                          size="xs"
                          colorScheme="blue"
                          isDisabled={
                            Number(data.referralPoints) <= 0
                          }
                          onClick={() => setOpenPinModal(true)}
                        >
                          Convert to E-Points
                        </Button>
                      </Flex>
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </TableContainer>

            <Text w="full" pl={4} py={1.5}>
              Characters on RAN Online PH:
            </Text>

             <Stack w="full" px={4} columns={1} spacing={2}>
            {data.characters.map((data, index) => (
              <Flex key={`my-characters-${index + 1}`} align="center">
                <Box boxSize={50} mr={1}>
                  <Image src={getClassImage(data.classId)} alt={data.class} />
                </Box>
                <Box flex={1} fontSize={12}>
                  <Flex align="center" mb={-0.5}>
                    <Image
                      h="10px"
                      src={getSchoolSmallLogo(data.school)}
                      alt="school"
                      mr={2}
                    />
                    <Text flex={1} fontSize={14} fontWeight={700}>
                      {data.name}
                    </Text>
                    <Badge>{index + 1}</Badge>
                  </Flex>
                  <p>
                    Level: <b>{data.level}</b>
                    {' | '}
                    Gold:{' '}
                    <span
                      style={{
                        color: 'var(--chakra-colors-gold)',
                        fontWeight: 700
                      }}
                    >
                      {data.gold}
                    </span>
                    {' | '}
                    Status:{' '}
                    <span
                      style={{
                        color: `var(--chakra-colors-main-${
                          data.status === 'deleted' ? 'red' : 'green'
                        })`,
                        fontWeight: 700
                      }}
                    >
                      {data.status}
                    </span>
                  </p>
                </Box>
              </Flex>
            ))}
          </Stack>
        </>
      )}
    </Modal>

      {/* PIN MODAL */}
      <Modal
        header="Confirm Conversion"
        isOpen={openPinModal}
        onClose={() => setOpenPinModal(false)}
        fitContent
      >
        <Stack spacing={3}>
          <Text fontSize="sm">
            Enter your PIN code to convert Referral Points.
          </Text>

          <Input
            type="password"
            placeholder="PIN Code"
            value={pinCode}
            onChange={e => setPinCode(e.target.value)}
          />

          <Button
            colorScheme="green"
            onClick={handleConvert}
            isDisabled={!pinCode}
          >
            Confirm
          </Button>
        </Stack>
      </Modal>
    </>
  )
}

export default View
